import { Controller } from "@hotwired/stimulus"

// Ensures the modal contains exactly one (new) ScaleUsage form when opened via the + overlay.
// Also removes that form if the modal is closed without the user entering anything.
export default class extends Controller {
  static targets = ["template", "container"]

  connect() {
    this.modalElement = this.element.closest(".modal")
    if (!this.modalElement) return

    this._onShown = this.ensureOne.bind(this)
    this._onHidden = this.cleanupIfBlank.bind(this)

    this.modalElement.addEventListener("shown.bs.modal", this._onShown)
    this.modalElement.addEventListener("hidden.bs.modal", this._onHidden)
  }

  disconnect() {
    if (!this.modalElement) return
    this.modalElement.removeEventListener("shown.bs.modal", this._onShown)
    this.modalElement.removeEventListener("hidden.bs.modal", this._onHidden)
  }

  ensureOne() {
    if (!this.hasContainerTarget || !this.hasTemplateTarget) return
    if (this.containerTarget.children.length > 0) return

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now().toString())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  cleanupIfBlank() {
    if (!this.hasContainerTarget) return
    if (this.containerTarget.children.length !== 1) return

    const root = this.containerTarget.children[0]
    const fields = root.querySelectorAll("input, select, textarea")

    const hasValue = Array.from(fields).some((el) => {
      if (el.type === "hidden") return false
      if ((el.name || "").endsWith("[_destroy]")) return false
      return (el.value || "").trim() !== ""
    })

    if (!hasValue) this.containerTarget.innerHTML = ""
  }
}
